import React, { PureComponent } from "react";

import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

import { Input, Grid, Col, CheckMark } from "../../components";
import { messages, constants } from "../../constants";

import { validationBuilder, validations } from "../../containers/form";
import { Txt, Button, Title } from "../../elements";

import { convertToSentenceCase, validateEmail } from "../../util";

import businessReferImage from "../../assets/img/business-refer.png";
import "./index.scss";
import { EmailFormData } from "../../util/emailFormData";
import RequiredFieldFooterNote from "../../containers/form/fieldGroups/requiredFieldFooterNote";

let rules = {};
const settings = {
  form: constants.FORM.businessReferralForm, // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
};
class BusinessReferral extends PureComponent {
  rulePhone = [];
  state = {
    clientSideValidationError: null,
    resetSuccess: false
  };

  constructor(props) {
    super(props);
    // for field level validations
    // TODO: find a better way to instantiate props when the component mounts
    Object.keys(validations).forEach((key) => {
      rules[key] = (spec) => (value) => validationBuilder(props, validations[key], spec)(value);
    });
    const { intl } = props;
    this.ruleCompanyName = [
      rules.required(intl.formatMessage(messages.businessReferral.companyName)),
    ];
    this.ruleFirstName = [
      rules.required(intl.formatMessage(messages.personal.firstName)),
      rules.names(intl.formatMessage(messages.personal.firstName))
    ];
    this.ruleLastName = [
      rules.required(intl.formatMessage(messages.personal.lastName)),
      rules.names(intl.formatMessage(messages.personal.lastName))
    ];
    this.rulesEmail = [
      rules.required(intl.formatMessage(messages.field.EmailAddress)),
      rules.email()
    ];
    this.rulePhone = [rules.phone()];
  }

  sendEmail = async (payload) => {
    const { intl } = this.props;
    if (!validateEmail(payload.email)) {
      this.setState({ clientSideValidationError: intl.formatMessage(messages.error.email) });
      return null;
    }
    const emailFormData = new EmailFormData(payload, constants.EMAIL_TYPE.BUSINESS_REFERRAL)
    
    try {
      const resp = await fetch(constants.ENDPOINTS.sendEmail, {
        method: "POST",
        body: emailFormData.getFormData()
      });

      if (resp.status !== 200) {
        this.setState({
          clientSideValidationError: "Something went wrong!",
          resetSuccess: false
        });
      } else {
        this.setState({
          clientSideValidationError: null,
          resetSuccess: true
        });
      }
      return resp;
    } catch (error) {
      this.setState({
        clientSideValidationError: error.message,
        resetSuccess: false
      });
      //   throw error;
    }
  };

  renderSuccessfulScreen = () => {
    const { intl } = this.props;

    return (
      <div className="reset-code" data-testid="business-referral-success" id="business-referral-success">
        <Grid theme={["center"]}>
          <Col size="1-2" min="sm">
            <CheckMark />
            <Title
              priority={1}
              type={["strong"]}
              style={{
                padding: "50px"
              }}
              className="h1 reset-code__title blue"
            >
              {intl.formatMessage(messages.businessReferral.successMessage)}
            </Title>
            <Title priority={5} className="h5 reset-code__title">
              {intl.formatMessage(messages.businessReferral.successMessageDescription)}
            </Title>
          </Col>
        </Grid>
      </div>
    );
  };

  render() {
    const { submitting, invalid, pristine, intl, handleSubmit } = this.props;

    if (this.state.clientSideValidationError) {
      return (
        <div data-testid="business-referral-error" id="business-referral-error" style={{ display: "contents" }}>
          {this.state.clientSideValidationError}
        </div>
      );
    }

    if (this.state.resetSuccess) {
      return this.renderSuccessfulScreen();
    }
    return (
      <div className="outerForm">
        <img
          style={{ width: "100%", height: "400px", objectFit: "cover" }}
          src={businessReferImage}
          alt="EvoApp"
        />
        <div style={{ padding: "30px 0" }}>
          <form
            model={constants.FORM.contactUsBusinessForm}
            onSubmit={handleSubmit(this.sendEmail)}
            noValidate
          >
            <Title priority={1} type={["strong-no-cap"]} style={{ fontSize: "1.5rem" }}>
              {convertToSentenceCase(intl.formatMessage(messages.businessReferral.title))}
            </Title>
            <Txt theme={[`middle`, `large`]}>
              {intl.formatMessage(messages.businessReferral.description)}
            </Txt>
            <Grid
              className={"business-form"}
              style={{ padding: "0", margin: "0", gridGap: "20px" }}
            >
              <Col size="1-2" min="sm">
                <br /><br />
                <Txt>{intl.formatMessage(messages.businessReferral.businessNameText)}</Txt>
                <Field
                  type="text"
                  name="companyName"
                  label={intl.formatMessage(messages.businessReferral.companyName)}
                  required={true}
                  component={Input}
                  validate={this.ruleCompanyName}
                  props={{ maxLength: "50" }}
                />
              </Col>
              <Col size="3-4" min="sm">
                <br /><br />
                <Title priority={2} type={["strong-no-cap"]}>
                  {intl.formatMessage(messages.businessReferral.businessContactSectionTitle)}
                </Title>
              </Col>
              <Col size="1-2" min="sm">
                <Field
                  type="text"
                  name="firstNameBusiness"
                  label={intl.formatMessage(messages.businessReferral.firstName)}
                  required={true}
                  component={Input}
                  validate={this.ruleFirstName}
                  props={{ maxLength: "50" }}
                />
              </Col>
              <Col size="1-2" min="sm">
                <Field
                  type="text"
                  name="lastNameBusiness"
                  label={intl.formatMessage(messages.businessReferral.lastName)}
                  required={true}
                  component={Input}
                  validate={this.ruleLastName}
                  props={{ maxLength: "50" }}
                />
              </Col>
              <Col size="2-4" min="sm">
                <Field
                  type="email"
                  name="emailBusiness"
                  label={intl.formatMessage(messages.businessReferral.email)}
                  required={true}
                  validate={this.rulesEmail}
                  component={Input}
                  props={{ maxLength: "50" }}
                />
              </Col>
              <Col size="2-3" min="sm">
                <Field
                  type="tel"
                  name="phoneNumberBusiness"
                  label={intl.formatMessage(messages.businessReferral.phone)}
                  component={Input}
                  validate={this.rulePhone}
                  required={true}
                  props={{ maxLength: "20" }}
                />
              </Col>
              <Col size="1-1" min="sm">
                <Field
                  type="text"
                  name="message"
                  label={intl.formatMessage(messages.businessReferral.additionalInfoText)}
                  component={Input}
                  props={{ maxLength: "160" }}
                />
              </Col>
              <Col size="3-4" min="sm">
                <br /><br />
                <Title priority={2} type={["strong-no-cap"]}>
                  {intl.formatMessage(messages.businessReferral.contactInfoTitle)}
                </Title>
              </Col>
              <Col size="1-2" min="sm">
                <Field
                  type="text"
                  name="firstName"
                  label={intl.formatMessage(messages.personal.firstName)}
                  required={true}
                  component={Input}
                  validate={this.ruleFirstName}
                  props={{ maxLength: "50" }}
                />
              </Col>
              <Col size="1-2" min="sm">
                <Field
                  type="text"
                  name="lastName"
                  label={intl.formatMessage(messages.personal.lastName)}
                  required={true}
                  component={Input}
                  validate={this.ruleLastName}
                  props={{ maxLength: "50" }}
                />
              </Col>
              <Col size="2-4" min="sm">
                <Field
                  type="email"
                  name="email"
                  label={intl.formatMessage(messages.field.EmailAddress)}
                  required={true}
                  validate={this.rulesEmail}
                  component={Input}
                  props={{ maxLength: "50" }}
                />
                <Txt>
                  <small>{intl.formatMessage(messages.businessReferral.personalEmailSubtext)}</small>
                </Txt>
              </Col>
              <Col size="3-4" min="sm">
                <RequiredFieldFooterNote />
              </Col>
            </Grid>
            <br />
            <Button
              loading={submitting}
              type="submit"
              theme={["cta"]}
              disabled={invalid || submitting || pristine}
            >
              {intl.formatMessage(messages.button.submit)}
            </Button>
          </form>
        </div>
      </div>
    );
  }
}

BusinessReferral.propTypes = {
  intl: PropTypes.object.isRequired,
  submitting: PropTypes.bool
};

BusinessReferral.defaultProps = {
  button: "",
  submitting: false
};

const mapStateToProps = (state) => ({
  state
});

const enhancer = compose(injectIntl, connect(mapStateToProps), reduxForm(settings));

export default enhancer(BusinessReferral);
